import { createSelector } from 'reselect';
import { sephoraMachineLearningModelV2Selector } from 'selectors/testTarget/offers/sephoraMachineLearningModelV2/sephoraMachineLearningModelV2Selector';

const showSelector = createSelector(sephoraMachineLearningModelV2Selector, sephoraMachineLearningModelV2 => !!sephoraMachineLearningModelV2.show);

export { showSelector };
